/** Латиница + цифры для сегментов URL (бренд, модель). */

const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ё: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sch",
  ъ: "",
  ы: "y",
  ь: "",
  э: "e",
  ю: "yu",
  я: "ya",
  ғ: "g",
  қ: "q",
  ҳ: "h",
  ҷ: "j",
  ӯ: "u",
  ӣ: "i",
};

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isCarUuidParam(param: string): boolean {
  return UUID_RE.test(param.trim());
}

function transliterateChar(ch: string): string {
  const lower = ch.toLowerCase();
  if (CYRILLIC_TO_LATIN[lower]) return CYRILLIC_TO_LATIN[lower];
  return ch;
}

/** Один сегмент пути: марка, модель или название компании. */
export function slugifyCarSegment(raw: string, maxLen = 48): string {
  const s = raw
    .trim()
    .split("")
    .map(transliterateChar)
    .join("")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "");
  const slug = s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, maxLen)
    .replace(/-+$/g, "");
  return slug || "x";
}

const ID_SUFFIX_LEN = 12;

/** Первые 12 hex-символов UUID без дефисов — суффикс SEO-slug. */
export function compactUuidSlugSuffix(id: string): string {
  return id.replace(/-/g, "").slice(0, ID_SUFFIX_LEN).toLowerCase();
}

/** Уникальный человекочитаемый slug: brand-model-year-{id prefix}. */
export function buildCarSlug(id: string, brand: string, model: string, year: number): string {
  const b = slugifyCarSegment(brand);
  const m = slugifyCarSegment(model);
  const y = Number.isFinite(year) ? String(Math.trunc(year)) : "0";
  const suffix = compactUuidSlugSuffix(id);
  return `${b}-${m}-${y}-${suffix}`;
}

export type CarLinkFields = {
  id: string;
  slug?: string | null;
  brand: string;
  model: string;
  year: number;
};

/** Публичный путь карточки (всегда с описательным slug). */
export function carDetailPath(car: CarLinkFields): string {
  const s = car.slug?.trim();
  if (s) return `/cars/${s}`;
  return `/cars/${buildCarSlug(car.id, car.brand, car.model, car.year)}`;
}
